//declare var jQuery:any;
//declare var $:any;

// Imports Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Compiler } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

// External Modules
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './configuracion/material.module';
import { SessionStorageService } from 'ngx-webstorage';
import { Ng2Webstorage } from 'ngx-webstorage';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { Logger } from 'angular2-logger/core';
import { RecaptchaModule } from 'ng-recaptcha';

// Components view
import { AppComponent } from './app.component';
import { SelectorComponent } from './components/selector/selector.component';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DNotificacionesComponente } from '@dian-cmp/notificaciones';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

// Libs framework
import { DLogger } from '@dian/core';
import { DLoggerAngular } from '@dian/core';
import { DContextoMuiscaServicio } from '@dian/core';
import { DSessionStorage } from '@dian/core';
import { DContextoMuiscaDesaServicio } from '@dian/core';
import { DFormularioServicio } from '@dian/api-formulario';
import { FiltroFormatosPipe } from './pipes/filtro-formatos.pipe';
import { ArraySortPipe } from './pipes/array-sort.pipe';
import { MessageService } from './resources/services/message.service';

// Conf
import { loggerFactory, contextoMuiscaFactory, formularioFactory, sessionStorageFactory } from './configuracion/app.factories';
import { AppRoutingModule } from './app-routing.module';
import { FormatosComponent } from './resources/components/formatos/formatos.component';
import { SeleccionAnioComponent } from './resources/components/seleccion-anio/seleccion-anio.component';
import { RecaptchaComponent } from './resources/components/recaptcha/recaptcha.component';

@NgModule({
  declarations: [
    AppComponent,
    SelectorComponent,
    DNotificacionesComponente,
    DEnvioLogComponente,
    FiltroFormatosPipe,
    ArraySortPipe,
    FormatosComponent,
    SeleccionAnioComponent,
    RecaptchaComponent
  ],
  imports: [
    //Angular
    BrowserModule,
    HttpModule, 
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    //External
    Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    }),
    RecaptchaModule.forRoot(),
    //Material
    FlexLayoutModule,
    MaterialModule,
    //Aplicacion
    AppRoutingModule 
  ],
  providers: [
    CookieService, 
    Compiler,
    Logger,
    DNotificacionServicio,       
    {
        provide: DLogger,
        useFactory: loggerFactory,
        deps: [Logger, SessionStorageService]
    },
    {
        provide: DSessionStorage,
        useFactory: sessionStorageFactory,
        deps: [SessionStorageService,DLogger]
    },
    {
        provide: DContextoMuiscaServicio,
        useFactory: contextoMuiscaFactory,
        deps: [Http, CookieService, Compiler, DLogger, DNotificacionServicio, DSessionStorage]
    },
    {
        provide:  DFormularioServicio,
        useFactory: formularioFactory,
        deps: [DContextoMuiscaServicio]            
    },
    MessageService  
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    DNotificacionesComponente, 
    DEnvioLogComponente,
    SeleccionAnioComponent,
    RecaptchaComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/app.module.ts